// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1ba2s","title":"AfterBackImages_title__2E7fj","images":"AfterBackImages_images__VwJb_"};